import funnelSvg from '../../res/metric-funnel.svg';

interface MetricFunnelProps {
  height?: number;
}

const ORIGINAL_WIDTH = 158;
const ORIGINAL_HEIGHT = 245;
const ASPECT_RATIO = ORIGINAL_WIDTH / ORIGINAL_HEIGHT;

const MetricFunnel = ({ height = 200 }: MetricFunnelProps) => {
  const width = Math.round(height * ASPECT_RATIO);

  return (
    <div className="flex items-center shrink-0" style={{ height, width }}>
      <img src={funnelSvg} alt="" width={width} height={height} />
    </div>
  );
};

export default MetricFunnel;
